export default [
    {
        path: 'financial/:id?/:activeDialog?/:activeId?/:activeGroupId?',
        name: 'financial-page',
        component: () => import('../views/FinancialDashboard'),
        props: true,
    },
];
